export default __webpack_public_path__ + "static/media/AI.6bed8c25.png";